import CustomerLoyaltyService from 'services/loyalty-service';

import userService from '../../../services/user-service';

const LOAD_LOYALTY_POINTS = 'LOAD_LOYALTY_POINTS'
const LOAD_LOYALTY_POINTS_FOR_REDEEM = 'LOAD_LOYALTY_POINTS_FOR_REDEEM'
const SEND_OTP = 'SEND_OTP'

export function loadLoyaltyPoints(mobileNumber, businessUnitId) {
  return (dispatch, getState) => {
    return CustomerLoyaltyService.getUserLoyaltyPoints(mobileNumber, businessUnitId)
      .then((loyaltyDetails) => {
        dispatch({
          type: LOAD_LOYALTY_POINTS,
          loyaltyPoints: loyaltyDetails
        })
      })
  }
}

export function loadLoyaltyPointsRedeem(mobileNumber, businessUnitId) {
  return (dispatch, getState) => {
    return CustomerLoyaltyService.getUserLoyaltyPointsRedeem(mobileNumber, businessUnitId)
      .then((loyaltyDetails) => {
        dispatch({
          type: LOAD_LOYALTY_POINTS_FOR_REDEEM,
          loyaltyPointsRedeem: loyaltyDetails
        })
      })
  }
}

export function sendOtp(body, sendOtpBody) {
  return (dispatch, getState) => {
    return userService.getOtp(body)
      .then((otpDetails) => {
        let otpCode = _.get(otpDetails, 'data.code')
        let sendOtpRequestBody = _.assign(sendOtpBody,{otp: otpCode})
        return userService.sendOtpToUser(sendOtpRequestBody).then((otp)=> {
          dispatch({
            type: SEND_OTP,
            otpInfo: otpDetails
          })
        })
      })
  }
}

export function loyaltyPointsReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_LOYALTY_POINTS : {
      return action.loyaltyPoints
    }
    default :
      return state
  }
}

export function loyaltyPointsRedeemReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_LOYALTY_POINTS_FOR_REDEEM : {
      return action.loyaltyPointsRedeem
    }
    default :
      return state
  }
}

export function sendOtpReducer(state = {}, action) {
  switch (action.type) {
    case SEND_OTP : {
      return action.otpInfo
    }
    default :
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/LoyaltyRedeem/modules/LoyaltyRedeem.js